// extracted by mini-css-extract-plugin
export var dropdown = "_qy-0";
export var imageWrapper = "_qy-3";
export var itemNameContainer = "_qy-1";
export var productImage = "_qy-2";
export var spinnerWrapper = "_qy-4";